import getStore from '../store/store';

export default function getLastFindMeetingTimesRequestId() {
    const store = getStore();
    return store.lastFindMeetingTimesRequestId;
}
